import { useTranslation } from 'react-i18next';

export const useFontFamily = () => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';

  return {
    fontFamily: isArabic ? 'var(--font-family-arabic)' : undefined,
  };
}; 